import { useMemo } from "react";

export type CompanyListItem = {
  displayName: string;
  name: string;
  oib: string;
};

export function useCompanyListFilter<T extends CompanyListItem>(
  items: T[] | undefined,
  search: string,
): T[] | undefined {
  return useMemo(() => {
    if (!items) return undefined;
    const q = search.trim().toLowerCase();
    if (!q) return items;
    return items.filter(
      (c) =>
        c.displayName.toLowerCase().includes(q) ||
        c.name.toLowerCase().includes(q) ||
        c.oib.includes(search.trim()),
    );
  }, [items, search]);
}
